import { render, staticRenderFns } from "./FilterTraditionalGame.vue?vue&type=template&id=49791d40&scoped=true&"
import script from "./FilterTraditionalGame.vue?vue&type=script&lang=js&"
export * from "./FilterTraditionalGame.vue?vue&type=script&lang=js&"
import style0 from "./FilterTraditionalGame.vue?vue&type=style&index=0&id=49791d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49791d40",
  null
  
)

export default component.exports